export default __webpack_public_path__ + "static/media/home_bottom_img_Hk.9ac1dcbd.webp";